import MenuTabs, { MenuTab } from '@superfunnel/ui-core/MenuTabs';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export default function SettingsWrapper() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs: MenuTab[] = useMemo(() => {
    const currentTab = location.pathname.split('/')[4];

    const items = [
      { name: 'Website', id: 'website' },
      { name: 'AI Settings', id: 'ai-settings' },
      { name: 'Forms', id: 'forms' },
      { name: 'Ad Accounts', id: 'ad-accounts' },
      { name: 'Integrations', id: 'integrations' },
      { name: 'Billing', id: 'billing' },
      { name: 'Profile & Team', id: 'organization' },
    ];

    return items.map((item) => ({
      ...item,
      current: currentTab === item.id,
    }));
  }, [location]);

  return (
    <div className="flex h-full flex-col gap-2 overflow-hidden px-3 py-3 lg:px-10 lg:py-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage your workspace settings and preferences
        </p>
      </div>
      <MenuTabs
        className={'border-base-200 border-b [&_button]:mr-5'}
        tabs={tabs}
        onTabClick={(tab) => {
          navigate(`./${tab}`);
        }}
      />
      <div className="flex-1 overflow-auto pt-6">
        <Outlet />
      </div>
    </div>
  );
}
